import { BaseCrudService } from "@/services/base";

class AuthService extends BaseCrudService<any> {
    constructor() {
        super({
            apiPrefix: "auth",
            entityName: "authentication",
        });
    }

    async getPermissions() {
        try {
            const res = await this.axios.get(`/perms`);
            return res.data;
        } catch (e) {
            this.tosti.error({
                message: `Could not retrieve permissions: ${e.response?.data?.message || e.message}`,
            });
            throw e;
        }
    }
}

export const authService = new AuthService();
